/**
 * Shared visual components for the auth sheets (ARC-145 designs): the back
 * chevron and the field-level error chrome (red label asterisk · helper text
 * under the field). Components only — non-component helpers (input classes,
 * CTA classes, email validation) live in `auth-form-style.ts` so this file
 * stays Fast-Refresh-safe.
 */

/** Purple back chevron pinned to the sheet's top-left corner. */
export function SheetBackButton({ testId, onClick }: { testId: string; onClick: () => void }) {
  return (
    <button
      data-testid={testId}
      type="button"
      onClick={onClick}
      aria-label="Back"
      className="absolute left-0 top-0 p-1 text-purple hover:opacity-80"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}

/** Field label; a red asterisk marks the field carrying the current error. */
export function FieldLabel({ htmlFor, error, children }: { htmlFor: string; error?: boolean; children: React.ReactNode }) {
  return (
    <label htmlFor={htmlFor} className="text-base text-ink px-[22px]">
      {children}
      {error && <span className="text-danger-alt">*</span>}
    </label>
  );
}

/** Red helper line rendered directly under the offending field. */
export function FieldErrorText({ testId, children }: { testId: string; children: React.ReactNode }) {
  return (
    <p data-testid={testId} role="alert" className="text-xs text-danger-alt px-[22px] pt-1">
      {children}
    </p>
  );
}
